import BossModel from "@/models/BossModel";
import Product from "@/models/Proposal/Product/Product";
import AgentProduct from "@/models/Agent/Product/Product";

export default class AgentPreset extends BossModel {

    static apiUrl = 'proposal/product/agent-preset';

    static entity = 'proposalProductAgentPresets';

    static fields() {
        return {
            id: this.number(null).nullable(),
            hash: this.attr(null),
            name: this.attr(null),
            reference: this.attr(null),
            notes: this.attr(null),
            is_price_accepted: this.boolean(0),
            product: this.hasOne(Product, 'proposal_product_agent_preset_id'),
            agentProduct: this.hasOne(AgentProduct, 'hash', 'hash'),
        }
    }

    hasRequiredReference() {
        const product = this.constructor.query()
            .with(['product.agentCode.agent'])
            .find(this.id).product;

        if (product.agentCode.agent.is_agent_reference_required) {
            return !!this.reference;
        }

        return true;
    }
}
